var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 12.3333H12.3333M9.73588 2.11228C9.87717 1.97099 10.0449 1.85891 10.2295 1.78245C10.4141 1.70598 10.612 1.66663 10.8118 1.66663C11.0116 1.66663 11.2094 1.70598 11.394 1.78245C11.5787 1.85891 11.7464 1.97099 11.8877 2.11228C12.029 2.25357 12.141 2.4213 12.2175 2.6059C12.294 2.79051 12.3333 2.98836 12.3333 3.18817C12.3333 3.38799 12.294 3.58584 12.2175 3.77044C12.141 3.95505 12.029 4.12278 11.8877 4.26407L4.62537 11.5264L1.66666 12.3333L2.47358 9.37458L9.73588 2.11228Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cfda1bd5a9fc651380f1171fab2d0c1a.svg";
export { ForwardRef as ReactComponent };